import Carousel from 'react-multi-carousel';
import CommonService from '../../../../services/commonService';
import React from 'react';

const responsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 4,
	},
	desktop: {
		breakpoint: { max: 2000, min: 1024 },
		items: 2,
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};

const SantarosaSlider = props => {
	const operator = CommonService.getLocal('op');
	return (

		operator && operator.operator_name === 'lineaazul' ?
			(<div className="themes-theme-two-slider new-container center-slider">

				<style>
					.themes-theme-two-slider .react-multi-carousel-dot--active button {'{'}
					background:
					{props.operator && props.operator.color_codes.button_color
						? props.operator.color_codes.button_color
						: '#FFA100'}
					;{'}'}
				</style>
				<Carousel
					responsive={responsive}
					swipeable={false}
					draggable={false}
					showDots={true}
					infinite={true}
					autoPlay={true}
					autoPlaySpeed={3000}
					customTransition="all .5"
					// transitionDuration={3000}
					removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
					slidesToSlide={1}
				>
					{props.slides &&
						(props.slides.length || []) > 0 &&
						props.slides.map((slide, index) => {
							return <SlideItem slide={slide} index={index} />;
						})}
				</Carousel>
			</div>) : operator && operator.operator_name === 'santarosa' ? (<div className="themes-theme-two-slider new-container santa-slider-changes recom-slider">
				<style>
					.themes-theme-two-slider .react-multi-carousel-dot--active button {'{'}
					background:
					{props.operator && props.operator.color_codes.button_color
						? props.operator.color_codes.button_color
						: '#FFA100'}
					;{'}'}
				</style>
				<Carousel
					responsive={responsive}
					swipeable={false}
					draggable={false}
					showDots={true}
					infinite={true}
					autoPlay={true}
					autoPlaySpeed={3000}
					customTransition="all .5"
					// transitionDuration={3000}
					removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
					slidesToSlide={2}
				>
					{props.slides &&
						(props.slides.length || []) > 0 &&
						props.slides.map((slide, index) => {
							return <SlideItem slide={slide} index={index} />;
						})}
				</Carousel>
			</div>) : (<div className="themes-theme-two-slider new-container">
				<style>
					.themes-theme-two-slider .react-multi-carousel-dot--active button {'{'}
					background:
					{props.operator && props.operator.color_codes.button_color
						? props.operator.color_codes.button_color
						: '#FFA100'}
					;{'}'}
				</style>
				<Carousel
					responsive={responsive}
					swipeable={false}
					draggable={false}
					showDots={true}
					infinite={true}
					autoPlay={true}
					autoPlaySpeed={3000}
					customTransition="all .5"
					// transitionDuration={3000}
					removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
					slidesToSlide={2}
				>
					{props.slides &&
						(props.slides.length || []) > 0 &&
						props.slides.map((slide, index) => {
							return <SlideItem slide={slide} index={index} />;
						})}
				</Carousel>
			</div>)


	);
};

const SlideItem = props => {
	return (
		<div className="slide-item" key={props.index}>
			<div className="image-container">
				<a href={props.slide.url} target="_blank" rel="noreferrer">
					<img className="image" src={props.slide.path} alt={props.slide} />
				</a>
			</div>
		</div>
	);
};

export default SantarosaSlider;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/SantroSlider.js